import { isNull, isUndefined } from 'lodash';
import { isTransactionRestrictedForFundingBank } from 'src/utils/funds/shared/shared-fund-notes-utility';
import {
  isAppBuy,
  isAppSell,
  isAutomaticSell,
  isBuy,
  isCollegeContribute,
  isCollegeDistribute,
  isIRAAutoMax,
  isRecurringBuy,
  isRecurringBuyEdit,
  isSell,
} from 'src/utils/transactions-util';
import { isJustAdded } from 'src/utils/utils';

export const isDisabled = ({ automaticEditFund, agreementMap }, bank) => {
  if (checkIfUndefined(bank)) {
    return true;
  }
  const {
    bankAwaitingVerification,
    corruptBankData,
    hasRedemptionHold,
    quovoBank,
  } = bank;

  if (corruptBankData) {
    return corruptBankData;
  }
  if (
    isRecurringBuyEdit() &&
    automaticEditFund &&
    agreementMap[bank.bankAgreementID]
  ) {
    return getRecurringResponse(automaticEditFund, agreementMap, bank);
  }

  if (isBuy() || isCollegeContribute()) {
    return isJustAdded(bank) !== true && bankAwaitingVerification;
  }
  if (isRecurringBuy() || isIRAAutoMax() || isAppBuy()) {
    return (
      (isJustAdded(bank) && !quovoBank) ||
      (isJustAdded(bank) !== true && bankAwaitingVerification)
    );
  }
  if (isSell() || isCollegeDistribute() || isAutomaticSell() || isAppSell()) {
    return hasRedemptionHold || bankAwaitingVerification;
  }
  return false;
};

function checkIfUndefined(bank) {
  if (isUndefined(bank) || isNull(bank)) {
    return true;
  }
  return false;
}

function getRecurringResponse(automaticEditFund, agreementMap, bank) {
  const { bankAwaitingVerification, quovoBank } = bank;
  return (
    isTransactionRestrictedForFundingBank(
      automaticEditFund[0],
      agreementMap[bank.bankAgreementID]
    ) ||
    agreementMap[bank.bankAgreementID].associableAgreements.some(
      (itm) => automaticEditFund[0].uniqueKey === itm
    ) ||
    (isJustAdded(bank) && !quovoBank) ||
    (isJustAdded(bank) !== true && bankAwaitingVerification)
  );
}
